import React from 'react'
import { useRoutes, navigate } from 'raviger'
import Base from 'Views/Base'
import { cookiesToObject } from 'Helpers'
import { colorState, stylesState } from 'Constants'
import { useStore } from 'laco-react'

const configDefault = {
  noBase: false
}

let config = {
  noBase: false
}

// General
import Home from 'Views/ReportSelector/Home'
import Login from 'Views/Login'

const generalRoutes = {
  '/': () => <Home />,
  '/login': () => {
    config.noBase = true
    config.login = true
    return <Login />
  }
}
// Activity
import ActivityReportSelector from 'Views/ReportSelector/Activity'
import ActivityReport from 'Views/Reports/Activity'
import ActivityReportCluster from 'Views/Reports/Activity/cluster'

const activityRoutes = {
  '/activity': () => <ActivityReportSelector />,
  '/activity/report/': () => <ActivityReportCluster />,
  '/activity/report/:appCode': ({ appCode }) => (
    <ActivityReport appCode={appCode} />
  )
}

// Alert
import AlertReportSelector from 'Views/ReportSelector/Alert'
import AlertReport from 'Views/Reports/Alert'
import AlertReportCluster from 'Views/Reports/Alert/cluster'

const alertRoutes = {
  '/alerts': () => {
    colorState.set(state => ({
      secondary: colorState.get().alert
    }))
    return <AlertReportSelector />
  },
  '/alerts/report/': () => {
    colorState.set(state => ({
      secondary: colorState.get().alert
    }))
    return <AlertReportCluster />
  },
  '/alerts/report/:appCode': ({ appCode }) => {
    colorState.set(state => ({
      secondary: colorState.get().alert
    }))
    return <AlertReport appCode={appCode} />
  }
}

// Device
import DeviceReportSelector from 'Views/ReportSelector/Device'
import DeviceReport from 'Views/Reports/Device'
import DeviceReportCluster from 'Views/Reports/Device/cluster'

const deviceRoutes = {
  '/device': () => {
    colorState.set(state => ({
      secondary: colorState.get().device
    }))
    return <DeviceReportSelector />
  },
  '/device/report/': () => {
    colorState.set(state => ({
      secondary: colorState.get().device
    }))
    return <DeviceReportCluster />
  },
  '/device/report/:appCode': ({ appCode }) => {
    colorState.set(state => ({
      secondary: colorState.get().device
    }))
    return <DeviceReport appCode={appCode} />
  }
}

// Message
import MessageReportSelector from 'Views/ReportSelector/Message'
import MessageReport from 'Views/Reports/Message'
import MessageReportCluster from 'Views/Reports/Message/cluster'

const messageRoutes = {
  '/message': () => {
    colorState.set(state => ({
      secondary: colorState.get().message
    }))
    return <MessageReportSelector />
  },
  '/message/report/': () => {
    colorState.set(state => ({
      secondary: colorState.get().message
    }))
    return <MessageReportCluster />
  },
  '/message/report/:appCode': ({ appCode }) => {
    colorState.set(state => ({
      secondary: colorState.get().message
    }))
    return <MessageReport appCode={appCode} />
  }
}

import ArchiveReportSelector from 'Views/ReportSelector/Archive'
import ArchiveReport from 'Views/Reports/Archive'
import ArchiveReportCluster from 'Views/Reports/Archive/cluster'

// Archive
const archiveRoutes = {
  '/archive': () => {
    colorState.set(state => ({
      secondary: colorState.get().archived
    }))
    return <ArchiveReportSelector />
  },
  '/archive/report/': () => {
    colorState.set(state => ({
      secondary: colorState.get().archived
    }))
    return <ArchiveReportCluster />
  },
  '/archive/report/:appCode': ({ appCode }) => {
    colorState.set(state => ({
      secondary: colorState.get().archived
    }))
    return <ArchiveReport appCode={appCode} />
  }
}

export const routes = {
  ...generalRoutes,
  ...activityRoutes,
  ...alertRoutes,
  ...deviceRoutes,
  ...messageRoutes,
  ...archiveRoutes
}

export default () => {
  // Reset config
  config = { ...configDefault }
  colorState.set(state => ({ ...colorState.initialState }))
  if (cookiesToObject(document.cookie).loggedIn !== 'true') navigate('/login')
  let routeResult = useRoutes(routes)

  if (config.noBase) {
    // TODO: Properly implement config
    return routeResult
  }
  return <Base>{routeResult}</Base>
}
